/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment, PureComponent } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify'; //토스트(toast)
// import moment from "moment";
import axios from 'axios';
import '../../css/event230701.css';

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import moment from "moment";
// import axios from "axios";

class ContentItem8 extends PureComponent {
  state = {
    alram: 0,
  };
  _goContent = (contentSerial) => {
    const { setContentSerial } = this.props;
    setContentSerial(contentSerial);
  };
  UNSAFE_componentWillReceiveProps = (nextProps, nextState) => {
    //console.log(this.props.location.pathname)
    //console.log(nextProps.location)
    return this.props.childProps.reset !== nextProps.childProps.reset;
    //return true;
  };
  componentWillReceiveProps = (nextProps) => {
    ////console.log(nextProps)

    if (this.props.childProps.reset !== nextProps.childProps.reset) {
      this.setState({
        alram: 100,
      });
    }
  };

  _onExpect = async () => {
    const { contentSerial, img, title, alramFlag, _expect, grade } =
      this.props.childProps;

    const a = await _expect(contentSerial, img, title, alramFlag, grade);
    //console.log(a)
    //if(parseInt(a) === 100) {
    this.setState({
      alram: parseInt(a),
    });
    //}
  };
  _onExpectApi = () => {};
  _CommaFormatted = (str) => {
    //console.log('aaaaaaaaaaaaaaaa')
    var Money;
    Money = '';
    while (parseInt(str) >= 1000) {
      if (parseInt(str) / 1000 > 0) {
        if (parseInt(str) % 1000 === 0) {
          Money = ',' + (parseInt(str) % 1000) + '00' + Money;
        } else {
          if (parseInt(str) % 1000 > 99)
            Money = ',' + (parseInt(str) % 1000) + Money;
          else if (parseInt(str) % 1000 > 9)
            Money = ',0' + (parseInt(str) % 1000) + Money;
          else Money = ',00' + (parseInt(str) % 1000) + Money;
        }
      }
      str = parseInt(str) / 1000;
    }
    Money = parseInt(str) + Money;

    return Money;
  };
  _toggleAlram = async () => {
    const { loginId, history } = this.props;
    if (loginId === '' || loginId === null || loginId === undefined) {
      //toast.warn('로그인 후 이용해 주세요.')
      history.push('/login');
    } else {
      const result = await this._toggleAlramApi();
      const intReturn = result.data[0].intReturn; // 0 삭제됨 100 추가됨

      this.setState({
        alram: intReturn,
      });
      if (intReturn === 100) {
        toast.success(
          '알림 등록 성공~! 모바일 APP을 통해서만 알림을 받으실 수 있습니다.'
        );
      } else {
        toast.warn('알림 해제 성공~!');
      }
    }
  };
  _toggleAlramApi = () => {
    const { apiUrl, loginId } = this.props;
    const { contentSerial } = this.props.childProps;

    return axios
      .post(apiUrl + '/alramToggle', {
        params: {
          userid: loginId,
          contentSerial: contentSerial,
        },
      })
      .then((response) => response)
      .catch((error) => {
        toast.error('오류가 발생했습니다.');
        //alert('오류가 발생했습니다.')
      });
  };
  render() {
    const { contentSerial, img, comment, title } = this.props.childProps;
    const { alram } = this.state;
    const { imgUrl } = this.props;

    return (
      <Fragment>
        <div className="item">
          <div className="thumb">
            <a
              onClick={() => this._goContent(contentSerial)}
              style={{ cursor: 'pointer' }}
            >
              <img src={img} style={{ width: '100%' }} />
            </a>
          </div>
          <div className="info">
            <p className="date">
              <img
                src={imgUrl + '/img/event/event202307/ico_live.png'}
                alt="LIVE"
              />{' '}
              {comment}
            </p>
            <p className="subject">
              <a
                onClick={() => this._goContent(contentSerial)}
                style={{ cursor: 'pointer' }}
              >
                {title}
              </a>
              <div className="btn_bottom">
                {alram === 0 ? (
                  <img
                    src={imgUrl + '/img/event/event202307/thum_btn.png'}
                    style={{ cursor: 'pointer' }}
                    onClick={this._toggleAlram}
                  />
                ) : (
                  <img
                    src={imgUrl + '/img/event/event202307/thum_btn_un.png'}
                    style={{ cursor: 'pointer' }}
                    onClick={this._toggleAlram}
                  />
                )}
              </div>
            </p>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(ContentItem8));
